var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collaborator-count"},[_c('b-icon',{attrs:{"icon":"account"}}),_vm._v("\n  "+_vm._s(_vm.count)+"/"+_vm._s(_vm.total)+"\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }